import { render, staticRenderFns } from "./SetPermissionsForDeviceAccessGroups.vue?vue&type=template&id=78dfbe6d"
import script from "./SetPermissionsForDeviceAccessGroups.vue?vue&type=script&lang=js"
export * from "./SetPermissionsForDeviceAccessGroups.vue?vue&type=script&lang=js"
import style0 from "./SetPermissionsForDeviceAccessGroups.vue?vue&type=style&index=0&id=78dfbe6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports